import styled from 'styled-components';

export const FooterRoot = styled.footer`
    display: flex;
    flex-direction: column;
`;
